import React from "react";
import { Link } from "react-router";
import "./hero.css";

const Hero = ({ image, onContact }) => {
  return (
    <main id="home" className="hero">
      <div className="container hero-grid">
        <div>
          <span className="eyebrow">
            <span className="dot"></span>Engineering Manager · Solution Architect · Ohio, USA
          </span>
          <h1>
            Hello, I'm Gayan.
            <br />I architect &amp; deliver{" "}
            <span className="grad">enterprise-grade cloud, AI &amp; mobile</span> solutions.
          </h1>
          <p>
            A .NET &amp; cloud Solution Architect and Engineering Manager with 15+ years designing,
            reviewing and delivering enterprise-grade software. I lead architectural vision and
            technical strategy end-to-end — from cloud migration and DevSecOps to AI integration,
            secure system integration and high-availability platforms — while guiding and mentoring
            engineering teams.
          </p>
          <div className="hero-cta">
            <button className="btn btn-primary" type="button" onClick={onContact}>
              Contact Me →
            </button>
            <Link className="btn btn-ghost" to="/resume">
              View Résumé
            </Link>
          </div>
          <div className="chips">
            <span className="chip"><b>.NET</b></span>
            <span className="chip"><b>Azure</b> &amp; AWS</span>
            <span className="chip"><b>React</b> Native</span>
            <span className="chip"><b>AI</b> / GenAI</span>
            <span className="chip"><b>DevSecOps</b></span>
            <span className="chip"><b>Salesforce</b></span>
          </div>
        </div>
        <div className="portrait-wrap">
          <div className="portrait-glow"></div>
          <img className="portrait" src={image} alt="Gayan N. Wimalarathna" />
          <div className="float-card fc-1">
            <div className="n">15+</div>
            <div className="l">Years experience</div>
          </div>
          <div className="float-card fc-2">
            <div className="n">8</div>
            <div className="l">Certifications</div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="stats">
          <div className="stat"><div className="n">15+</div><div className="l">Years experience</div></div>
          <div className="stat"><div className="n">8</div><div className="l">Certifications</div></div>
          <div className="stat"><div className="n">Azure+AWS</div><div className="l">Multi-cloud</div></div>
          <div className="stat"><div className="n">25+</div><div className="l">Technologies</div></div>
        </div>
      </div>
    </main>
  );
};

export default Hero;
